import { loadConfig } from './utils/getAPI-config';
import { createRoot } from 'react-dom/client';
import 'regenerator-runtime/runtime';

// third-party
import { Provider as ReduxProvider } from 'react-redux';

// fonts
import 'assets/fonts/roboto-slab/roboto-slab.css';
import 'assets/fonts/lato/lato.css';

// SASS
import 'assets/styles/main.scss';

// scroll bar
import 'simplebar/dist/simplebar.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// apex-chart
import 'assets/third-party/apex-chart.css';
import 'assets/third-party/react-table.css';

// project-imports
import App from './App';
import { store } from 'store';
import { ConfigProvider } from 'contexts/ConfigContext';
import reportWebVitals from './reportWebVitals';
import { DialogProvider } from 'contexts/DialogueContext';
import { StrictMode } from 'react';

const container = document.getElementById('root');
const root = createRoot(container!);

// ==============================|| MAIN - REACT DOM RENDER  ||============================== //

/**
 * Adds an error event listener to the window object.
 * This listener checks for ChunkLoadError and reloads the page if such an error occurs.
 *
 * @param {(Event & { message?: string })} event - The error event object.
 */

const initApp = async () => {
  loadConfig().then(() => {
    root.render(
      <StrictMode>
        <ReduxProvider store={store}>
          <ConfigProvider>
            <DialogProvider>
              <App />
            </DialogProvider>
          </ConfigProvider>
        </ReduxProvider>
      </StrictMode>
    );
  });
};

initApp();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
